// Helper functions for generating Gender Graph chart data

import { getFilteredReportData } from '../helpers/filterHelpers'
import { GENDER_IMPACT } from '../fields'

const genderFields = {
  female: 'female',
  male: 'male',
  prefer_not_to_say: 'prefer_not_to_say',
  other: 'other',
  unknown: 'unknown'
}

const genderLabels = {
  [genderFields.female]: 'Female',
  [genderFields.male]: 'Male',
  [genderFields.prefer_not_to_say]: ['Prefer not to say'],
  [genderFields.other]: 'Other',
  [genderFields.unknown]: 'Unknown'
}

const genderColors = {
  [genderFields.female]: '#D08B67',
  [genderFields.male]: '#402022',
  [genderFields.prefer_not_to_say]: '#880055',
  [genderFields.other]: '#E2C6AA',
  [genderFields.unknown]: '#999999'
}

// Generate chart data for gender impact
const generateGenderImpactChartData = genderImpactData => {
  if (genderImpactData) {
    const labels = Object.values(genderLabels)
    const data = [
      genderImpactData[genderFields.female] || 0,
      genderImpactData[genderFields.male] || 0,
      genderImpactData[genderFields.prefer_not_to_say] || 0,
      genderImpactData[genderFields.other] || 0,
      genderImpactData[genderFields.unknown] || 0
    ]

    const colors = [
      genderColors[genderFields.female],
      genderColors[genderFields.male],
      genderColors[genderFields.prefer_not_to_say],
      genderColors[genderFields.other],
      genderColors[genderFields.unknown]
    ]

    return {
      labels: labels,
      datasets: [
        {
          label: 'Gender Distribution',
          data: data,
          backgroundColor: colors,
          spacing: 1,
          borderRadius: 8
        }
      ]
    }
  } else {
    return {
      labels: [],
      datasets: []
    }
  }
}

// Main function to generate chart data
export const generateGenderGraphData = ({ selectedRegion, selectedStakeholder, report }) => {
  const genderImpactData = getFilteredReportData({
    report,
    selectedRegion,
    selectedStakeholder,
    fieldName: GENDER_IMPACT
  })
  return generateGenderImpactChartData(genderImpactData)
}
